import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { ROUTE_PATH } from '../../../constants';
import { CitysprintWizardActions } from '../redux';

export function useCitysprintBackToParcelGuard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const requestBackToParcel = useCallback(() => {
    setConfirmOpen(true);
  }, []);

  const handleConfirm = useCallback(() => {
    setConfirmOpen(false);
    dispatch(CitysprintWizardActions.resetParcelTimingAndSelection());
    dispatch(CitysprintWizardActions.clearDetailsStep());
    navigate(ROUTE_PATH.SEND_A_CITYSPRINT_PARCEL);
  }, [dispatch, navigate]);

  const handleCancel = useCallback(() => {
    setConfirmOpen(false);
  }, []);

  return { confirmOpen, requestBackToParcel, handleConfirm, handleCancel };
}
